import { productionHost, STAGING_NOTICE_LEAD } from '@region13/shared-types'
import { NOTICE_CLASS } from './notice'

/** "TEST ENVIRONMENT", on a staging host only. Every email-code sign-in card
 *  renders it above its step switch, so it survives into the code step: that is
 *  the step that misleads somebody, because staging redirects the login code to
 *  NOTIFY_TEST_RECIPIENT and a person waiting for it never gets one.
 *
 *  ⚠️ THE HOSTNAME DECIDES, NEVER A `VITE_` FLAG. A missing flag on staging
 *  costs a banner; a flag leaked into a production build tells every user the
 *  live site is a test. `hostname` is a parameter only so tests can pass one.
 *
 *  The second line names the live site and links it: a referee landed here on
 *  2026-10-15, asked for a code, and waited for an email that went to the test
 *  recipient. The label alone did not send them on. `pathname` is a parameter
 *  for the same reason `hostname` is.
 *
 *  Bold because it is a true warning, the only thing bold is for here. */
export function StagingBanner({ hostname = window.location.hostname, pathname = window.location.pathname }: { hostname?: string; pathname?: string }) {
  const live = productionHost(hostname)
  if (!live) return null
  return (
    <div className={NOTICE_CLASS}>
      <p className="font-bold m-0">TEST ENVIRONMENT</p>
      <p className="m-0">
        {STAGING_NOTICE_LEAD}{' '}
        {/* Same page on the live site; the query is dropped (a login link's
            token belongs to staging). */}
        <a className="font-semibold underline" href={`https://${live}${pathname}`}>{live}</a> instead.
      </p>
    </div>
  )
}
